// extracted by mini-css-extract-plugin
export default {"paragraphContainer":"paragraph_paragraphContainer__v7NaG","heading":"paragraph_heading__o6Tzj","inputContainer":"paragraph_inputContainer__wgWOE"};